var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab-container mt-0"},[_c('div',{staticClass:"tabs w-100"},[_c('div',_vm._l((_vm.path),function(p,i){return _c('b-link',{key:i,staticClass:"tab-item",attrs:{"to":{name: p.route}}},[_vm._v(_vm._s(p.label))])}),1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }